export default __webpack_public_path__ + "static/media/closeFill.32cd0eb8.svg";